import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Bot, AlertTriangle } from 'lucide-react';
export function Problem() {
  return <SectionWrapper className="bg-brand-dark" data-id="element-174">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-175">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-176">
          <div data-id="element-177">
            <div className="inline-flex items-center gap-2 text-red-500 font-bold tracking-wider uppercase text-sm mb-4" data-id="element-178">
              <AlertTriangle className="w-5 h-5" data-id="element-179" />
              La Cruda Realidad
            </div>
            <h2 className="text-4xl md:text-5xl font-display mb-6 uppercase" data-id="element-180">
              Estás peleando contra{' '}
              <span className="text-brand-cyan" data-id="element-181">máquinas</span> usando
              herramientas de piedra.
            </h2>
            <div className="space-y-6 text-gray-300 text-lg" data-id="element-182">
              <p data-id="element-183">
                El sistema de crédito en Estados Unidos ha cambiado. En 2026,
                los burós como Experian y Equifax{' '}
                <strong className="text-white" data-id="element-184">ya no usan personas</strong> para
                leer tus quejas.
              </p>
              <p data-id="element-185">
                Usan Inteligencia Artificial para detectar y desechar "cartas de
                plantilla" en segundos.
              </p>
              <p className="p-4 bg-red-500/10 border-l-4 border-red-500 rounded-r-lg text-red-200" data-id="element-186">
                Si intentas usar los métodos viejos que viste en YouTube, el
                sistema te marcará como "frívolo" y tu puntaje no se moverá ni
                un solo punto.
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-187">
            <div className="absolute inset-0 bg-brand-cyan/20 blur-[100px] rounded-full" data-id="element-188"></div>
            <div className="relative bg-brand-card border border-gray-800 rounded-2xl p-8 overflow-hidden" data-id="element-189">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-cyan/10 blur-[50px]" data-id="element-190"></div>
              <Bot className="w-16 h-16 text-brand-cyan mb-6" data-id="element-191" />
              <h3 className="text-2xl font-display mb-4" data-id="element-192">
                Filtro de IA Activado
              </h3>
              <div className="space-y-3 font-mono text-sm" data-id="element-193">
                <div className="flex justify-between items-center p-3 bg-brand-dark rounded border border-gray-800" data-id="element-194">
                  <span className="text-gray-400" data-id="element-195">Análisis de carta...</span>
                  <span className="text-red-500" data-id="element-196">Plantilla detectada</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-brand-dark rounded border border-gray-800" data-id="element-197">
                  <span className="text-gray-400" data-id="element-198">Verificación humana...</span>
                  <span className="text-red-500" data-id="element-199">Omitida</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-red-500/20 rounded border border-red-500/50" data-id="element-200">
                  <span className="text-white" data-id="element-201">Estado de disputa:</span>
                  <span className="text-red-400 font-bold" data-id="element-202">
                    RECHAZADA (Frívola)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}